/**
* Create a new instance of StoryMixerTerm object
* @param  {object} StoryMixer A js object from novelist select
*/

class StoryMixerTerm {
	constructor(StoryMixer) {
		this.name = StoryMixer.name;
		this.description = StoryMixer.description;
		this.searchValue = StoryMixer.searchValue;
		this.category = StoryMixer.category;
	}
}

export default StoryMixerTerm;



// WEBPACK FOOTER //
// ./src/models/StoryMixerTerm.js